// src/hooks/useOrderSubmit.ts

import { useState } from "react";
import { buildOrderPayload, toFormData } from "@/utils/orderPayload";
import { useCart } from "@/hooks/useCart";
import { getSiteConfig } from "@/config/siteConfigs";

const CRM_ENDPOINT = "https://crm.hixa.eu/external/goodsapi/";
const CRM_TOKEN = "DH345DFGDGb32FDsf03876SDFSdf13";
const siteConfig = getSiteConfig();

async function sendToCrmFormUrlencoded(params: URLSearchParams) {
  const body = new URLSearchParams(params);
  body.set("legid", "1"); // 1, 5, 9, або 11
  body.set("language", siteConfig.language);

  try {
    const res = await fetch(CRM_ENDPOINT, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${CRM_TOKEN}`,
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        Accept: "application/json",
      },
      body: body.toString(),
    });

    return res;
  } catch (error) {
    console.error("Помилка при виконанні запиту:", error);
  }
}

export const useOrderSubmit = () => {
  const [loading, setLoading] = useState(false);
  const { cart, clearCart } = useCart();

  const submitOrder = async (formData: any, isFeedback = false) => {
    if (!cart || cart.length === 0) {
      alert("Der Warenkorb ist leer.");
      return false;
    }

    setLoading(true);

    const payload = buildOrderPayload(formData, cart);
    const formParams = toFormData(payload);

    // Додаємо feedback: 1 якщо це фідбек
    if (isFeedback) {
      formParams.set("feedback", "1");
    }

    try {
      const res = await sendToCrmFormUrlencoded(formParams);

      if (!res) {
        console.error("❌ Запит не відправлений: res undefined");
        alert("❌ Senden fehlgeschlagen. Bitte später erneut versuchen.");
        return false;
      }

      let bodyText = "";
      try {
        const data = await res.clone().json();
        bodyText = JSON.stringify(data, null, 2);

        if (data.success === 1) {
          // Очищаємо кошик
          localStorage.removeItem("cart");
          if (clearCart) clearCart();

          // Редірект
          if (isFeedback) {
            window.location.replace("/feedback_success");
          } else if (data.stripelink) {
            window.location.href = data.stripelink;
          }

          return true;
        } else if (data.success === 0) {
          const errorMessage = data.error || "Error.";
          console.error("❌ Error from server:", errorMessage);
          alert(errorMessage);
          return false;
        }
      } catch (err) {
        bodyText = await res.text();
        console.error("❌ Error parsing server response:", err);
      }

      if (res.ok) {
        // Google Tag Manager
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "order_submit",
          form_status: "success",
          form_name: isFeedback ? "feedback_form" : "order_form",
          total_items: payload.goods.length,
          unique_products: cart.length,
        });

        alert(
          `✅ ${payload.goods.length} Bestellung(en) wurden erfolgreich an das CRM gesendet.`
        );
        return true;
      } else {
        console.error("❌ CRM-Fehler", {
          httpStatus: res.status,
          responseBody: bodyText,
        });
        alert("❌ Senden fehlgeschlagen. Bitte später erneut versuchen.");
        return false;
      }
    } catch (err: any) {
      console.error("❌ Technischer Fehler beim Senden:", err);
      alert("❌ Technischer Fehler. Bitte später erneut versuchen.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    submitOrder,
  };
};
